import { render } from "./saleForm.vue?vue&type=template&id=aa295e8e&scoped=true"
import script from "./saleForm.vue?vue&type=script&lang=js"
export * from "./saleForm.vue?vue&type=script&lang=js"

import "./saleForm.vue?vue&type=style&index=0&id=aa295e8e&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa295e8e"]])

export default __exports__